// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"I8-z"};